import React from 'react';
import Avatar from 'components/Avatar';
import Flag from 'components/Flag';
export function CommentAvatarWrapper(_ref) {
  var pictureUrl = _ref.pictureUrl,
    _ref$isNested = _ref.isNested,
    isNested = _ref$isNested === void 0 ? false : _ref$isNested,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Flag, {
    spacing: "xs",
    align: "top",
    token: /*#__PURE__*/React.createElement(Avatar, {
      shady: true,
      scale: isNested ? 0.75 : 1,
      pictureUrl: pictureUrl
    }),
    ml: isNested ? 42 : null
  }, children);
}
export default CommentAvatarWrapper;